import React, { useEffect, useState } from 'react';
import style from './ApplicationField.style';
import {
  Button,
  CustomInput,
  Form,
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Label,
} from 'reactstrap';
import { faBox } from '@fortawesome/free-solid-svg-icons';
import { faSquare, faSquareCheck } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { DatePicker } from 'react-widgets/cjs';
import moment from 'moment';

const ApplicationField = (props) => {
  const { label, type, value, onChange, placeholder, required, fieldId, doValidate, disabled } = props;

  const [myValue, setMyValue] = useState();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    setMyValue(value);
  }, [label, value]);

  useEffect(() => {
    const handleResize = () => {
      const windowWidth = window.innerWidth;
      const windowHeight = window.innerHeight;

      if (windowWidth < windowHeight && windowWidth < 850) {
        setIsMobile(true);
      } else {
        setIsMobile(false);
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const renderInput = () => {
    if (isMobile) {
      switch (type) {
        case 'text':
          return (
            <Form style={{ width: '100%' }}>
              <FormGroup>
                <Label style={{ textWrap: 'wrap', textAlign: 'left' }} for={fieldId}>
                  {' '}
                  {label} {required ? <b style={{ color: 'red' }}>*</b> : ''}
                </Label>
                <Input
                  disabled={disabled}
                  invalid={doValidate && !value}
                  id={fieldId}
                  value={myValue ? myValue : ' '}
                  type="text"
                  style={{ height: 'auto', textWrap: 'wrap' }}
                  onChange={(e) => {
                    setMyValue(e.target.value);
                    onChange(e);
                  }}
                />
              </FormGroup>
            </Form>
          );
        case 'textarea':
          return (
            <Form style={{ width: '100%' }}>
              <FormGroup>
                <Label style={{ width: 'auto', textWrap: 'wrap', textAlign: 'left' }}>
                  {' '}
                  {label} {required ? <b style={{ color: 'red' }}>*</b> : ''}{' '}
                </Label>
                <Input
                  disabled={disabled}
                  invalid={doValidate && !value}
                  id={fieldId}
                  value={myValue ? myValue : ' '}
                  type="textarea"
                  rows={4}
                  style={{ height: 'auto', textWrap: 'wrap' }}
                  onChange={(e) => {
                    setMyValue(e.target.value);
                    onChange(e);
                  }}
                />
              </FormGroup>
            </Form>
          );

        case 'date':
          const formattedDate = myValue ? moment(myValue).format('YYYY-MM-DD') : null;

          const dateToDisplay = myValue ? new Date(formattedDate) : null;

          return (
            <Form style={{ width: '100%' }}>
              <FormGroup>
                <Label style={{ width: 'auto', textWrap: 'wrap', textAlign: 'left' }}>
                  {' '}
                  {label} {required ? <b style={{ color: 'red' }}>*</b> : ''}
                </Label>
                <DatePicker
                  value={dateToDisplay}
                  placeholder="Select a date"
                  valueFormat={{ month: 'short', year: 'numeric' }}
                  valueEditFormat={{ dateStyle: 'long' }}
                  valueDisplayFormat={{ dateStyle: 'long' }}
                  style={{ width: '100%' }}
                  disabled={disabled}
                  onToggle={() => {
                    // setShowPicker(!showPicker);
                  }}
                  onClick={(e) => {}}
                  onChange={(e) => {
                    setMyValue(e);
                    onChange({ target: { value: e } });
                  }}
                />
              </FormGroup>
            </Form>
          );

        case 'tel':
          return (
            <Form style={{ width: '100%' }}>
              <FormGroup>
                <Label style={{ width: 'auto', textWrap: 'wrap', textAlign: 'left' }}>
                  {' '}
                  {label} {required ? <b style={{ color: 'red' }}>*</b> : ''}
                </Label>
                <Input
                  disabled={disabled}
                  invalid={doValidate && !value}
                  id={fieldId}
                  value={myValue ? myValue : ' '}
                  type="tel"
                  rows={4}
                  style={{ height: 'auto', textWrap: 'wrap' }}
                  onChange={(e) => {
                    setMyValue(e.target.value);
                    onChange(e);
                  }}
                />
              </FormGroup>
            </Form>
          );
        case 'checkbox':
          return (
            <Form style={{ width: '100%' }}>
              <FormGroup>
                <Label style={{ width: 200, textWrap: 'wrap', textAlign: 'left' }}>
                  {' '}
                  {label} {required ? <b style={{ color: 'red' }}>*</b> : ''}
                </Label>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: '100%',
                    border: '1px solid lightgray',
                    borderRadius: 5,
                    alignItems: 'flex-start',
                    justifyContent: 'center',
                    padding: '6px 10px',
                    backgroundColor: disabled ? '#e9ecef' : 'white',
                    // borderRadius: '0 30px 30px 0',
                  }}
                >
                  <CustomInput
                    disabled={disabled}
                    invalid={doValidate && !value}
                    type="switch"
                    label={myValue ? 'Yes' : 'No'}
                    id={fieldId}
                    name={fieldId}
                    checked={myValue}
                    // checked={showPastInterviewDates == 'false' ? false : true}
                    onChange={(e) => {
                      setMyValue(e.target.checked);
                      onChange({ target: { value: e.target.checked } });
                    }}
                  />
                  {/* 
                  We might be eventually forced to use this, newer Bootstrap don't use CusotmInputs no more. 
                  <FontAwesomeIcon
                    icon={value == true ? faSquareCheck : faSquare}
                    style={{ fontSize: 24, cursor: disabled ? 'not-allowed' : 'pointer' }}
                    disabled={disabled}
                    onClick={(e) => {
                      if (disabled) {
                        e.stopPropagation();
                        return;
                      }
                      setMyValue(value);
                      onChange({ target: { value: !value } });
                    }}
                  /> */}
                </div>
              </FormGroup>
            </Form>
          );

        case 'switch':
          return (
            <InputGroup style={{ height: 'auto' }}>
              <InputGroupAddon addonType="prepend">
                <InputGroupText style={{ width: 200, textWrap: 'wrap', textAlign: 'left' }}>
                  {label}
                  {required ? <b style={{ color: 'red' }}>*</b> : ''}
                </InputGroupText>
              </InputGroupAddon>
              <Input style={{ width: '0px', display: 'none' }} />
              <InputGroupAddon addonType="append" style={{ width: 'calc(100% - 200px)', height: 'auto' }}>
                <InputGroupText style={{ width: '100%', backgroundColor: 'white' }}>
                  <CustomInput
                    disabled={disabled}
                    invalid={doValidate && !value}
                    type="switch"
                    label={myValue ? 'Yes' : 'No'}
                    id={fieldId}
                    name={fieldId}
                    checked={myValue}
                    // checked={showPastInterviewDates == 'false' ? false : true}
                    onChange={(e) => {
                      setMyValue(e.target.checked);
                      onChange(e);
                    }}
                  />
                </InputGroupText>

                {/* <div style={{ ...style.simpleColumn, border: '1px solid gray', width: '100%', borderRadius: 5 }}>
                  
                </div> */}
              </InputGroupAddon>
            </InputGroup>
          );
        default:
          return (
            <div>
              {label}: {type}
            </div>
          );
      }
    } else {
      switch (type) {
        case 'text':
          return (
            <InputGroup style={{ height: 'auto' }}>
              <InputGroupAddon addonType="prepend">
                <InputGroupText style={{ width: 200, textWrap: 'wrap', textAlign: 'left' }}>
                  <span>
                    {label}
                    {required ? <b style={{ color: 'red' }}>*</b> : ''}
                  </span>
                </InputGroupText>
              </InputGroupAddon>
              <Input
                size="sm"
                disabled={disabled}
                invalid={doValidate && !value}
                id={fieldId}
                value={myValue ? myValue : ' '}
                type="text"
                style={{ height: 'auto', textWrap: 'wrap' }}
                onChange={(e) => {
                  setMyValue(e.target.value);
                  onChange(e);
                }}
              />
            </InputGroup>
          );
        case 'textarea':
          return (
            <InputGroup style={{ height: 'auto' }}>
              <InputGroupAddon addonType="prepend">
                <InputGroupText style={{ width: 200, textWrap: 'wrap', textAlign: 'left' }}>
                  <span>
                    {label}
                    {required ? <b style={{ color: 'red' }}>*</b> : ''}
                  </span>
                </InputGroupText>
              </InputGroupAddon>
              <Input
                disabled={disabled}
                invalid={doValidate && !value}
                id={fieldId}
                value={myValue ? myValue : ' '}
                type="textarea"
                rows={4}
                style={{ height: 'auto', textWrap: 'wrap' }}
                onChange={(e) => {
                  setMyValue(e.target.value);
                  onChange(e);
                }}
              />
            </InputGroup>
          );
        case 'date':
          const formattedDate = myValue ? moment(myValue).format('YYYY-MM-DD') : null;

          const dateToDisplay = myValue ? new Date(formattedDate) : null;

          return (
            <InputGroup style={{ height: 'auto' }}>
              <InputGroupAddon addonType="prepend">
                <InputGroupText style={{ width: 200, textWrap: 'wrap', textAlign: 'left' }}>
                  <span>
                    {label}
                    {required ? <b style={{ color: 'red' }}>*</b> : ''}
                  </span>
                </InputGroupText>
              </InputGroupAddon>
              <InputGroupAddon addonType="append" style={{ width: 'calc(100% - 200px)', height: 'auto' }}>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: '100%',
                    border: '1px solid lightgray',
                    borderLeft: 'none',
                    alignItems: 'flex-start',
                    justifyContent: 'center',
                    backgroundColor: disabled ? '#e9ecef' : 'white',
                    // borderRadius: '0 30px 30px 0',
                  }}
                >
                  <DatePicker
                    disabled={disabled}
                    value={dateToDisplay}
                    placeholder="Select a date"
                    valueFormat={{ month: 'short', year: 'numeric' }}
                    valueEditFormat={{ dateStyle: 'long' }}
                    valueDisplayFormat={{ dateStyle: 'long' }}
                    style={{ width: '100%' }}
                    onToggle={() => {
                      // setShowPicker(!showPicker);
                    }}
                    onClick={(e) => {}}
                    onChange={(e) => {
                      setMyValue(e);
                      onChange({ target: { value: e } });
                    }}
                  />
                </div>
              </InputGroupAddon>
            </InputGroup>
          );
        case 'tel':
          return (
            <InputGroup style={{ height: 'auto' }}>
              <InputGroupAddon addonType="prepend">
                <InputGroupText style={{ width: 200, textWrap: 'wrap', textAlign: 'left' }}>
                  <span>
                    {label}
                    {required ? <b style={{ color: 'red' }}>*</b> : ''}
                    {`(${type})`}
                  </span>
                </InputGroupText>
              </InputGroupAddon>
              <Input
                disabled={disabled}
                invalid={doValidate && !value}
                id={fieldId}
                value={myValue ? myValue : ' '}
                type="tel"
                style={{ height: 'auto', textWrap: 'wrap' }}
                onChange={(e) => {
                  setMyValue(e.target.value);
                  onChange(e);
                }}
              />
            </InputGroup>
          );
        case 'checkbox':
          return (
            <InputGroup style={{ height: 'auto' }}>
              <InputGroupAddon addonType="prepend">
                <InputGroupText style={{ width: 200, textWrap: 'wrap', textAlign: 'left' }}>
                  <span>
                    {label}
                    {required ? <b style={{ color: 'red' }}>*</b> : ''}
                  </span>
                </InputGroupText>
              </InputGroupAddon>

              <InputGroupAddon addonType="append" style={{ width: 'calc(100% - 200px)', height: 'auto' }}>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: '100%',
                    border: '1px solid lightgray',
                    borderLeft: 'none',
                    alignItems: 'flex-start',
                    justifyContent: 'center',
                    paddingLeft: 10,
                    backgroundColor: disabled ? '#e9ecef' : 'white',
                    // borderRadius: '0 30px 30px 0',
                  }}
                >
                  <FontAwesomeIcon
                    icon={value == true ? faSquareCheck : faSquare}
                    style={{ fontSize: 24, cursor: disabled ? 'not-allowed' : 'pointer' }}
                    disabled={disabled}
                    onClick={(e) => {
                      if (disabled) {
                        e.stopPropagation();
                        return;
                      }
                      setMyValue(value);
                      onChange({ target: { value: !value } });
                    }}
                  />
                </div>
              </InputGroupAddon>
            </InputGroup>
          );
        case 'switch':
          return (
            <InputGroup style={{ height: 'auto' }}>
              <InputGroupAddon addonType="prepend">
                <InputGroupText style={{ width: 200, textWrap: 'wrap', textAlign: 'left' }}>
                  {label}
                  {required ? <b style={{ color: 'red' }}>*</b> : ''}
                </InputGroupText>
              </InputGroupAddon>
              <Input style={{ width: '0px', display: 'none' }} />
              <InputGroupAddon addonType="append" style={{ width: 'calc(100% - 200px)', height: 'auto' }}>
                <InputGroupText style={{ width: '100%', backgroundColor: 'white' }}>
                  <CustomInput
                    disabled={disabled}
                    invalid={doValidate && !value}
                    type="switch"
                    label={myValue ? 'Yes' : 'No'}
                    id={fieldId}
                    name={fieldId}
                    checked={myValue}
                    // checked={showPastInterviewDates == 'false' ? false : true}
                    onChange={(e) => {
                      setMyValue(e.target.checked);
                      onChange(e);
                    }}
                  />
                </InputGroupText>

                {/* <div style={{ ...style.simpleColumn, border: '1px solid gray', width: '100%', borderRadius: 5 }}>
                  
                </div> */}
              </InputGroupAddon>
            </InputGroup>
          );
        default:
          return (
            <div>
              {label}: {type}
            </div>
          );
          return (
            <InputGroup style={{ height: 'auto' }}>
              <InputGroupAddon addonType="prepend">
                <InputGroupText style={{ width: 200, textWrap: 'wrap', textAlign: 'left' }}>
                  <span>
                    {label}
                    {required ? <b style={{ color: 'red' }}>*</b> : ''}
                  </span>
                </InputGroupText>
              </InputGroupAddon>
              <Input
                disabled={disabled}
                invalid={doValidate && !value}
                id={fieldId}
                value={myValue ? myValue : ' '}
                type="text"
                style={{ height: 'auto', textWrap: 'wrap' }}
                onChange={(e) => {
                  setMyValue(e.target.value);
                  onChange(e);
                }}
              />
            </InputGroup>
          );
      }
    }
  };
  return (
    <div
      key={fieldId}
      style={{ ...style.simpleRow, marginBottom: 5, width: '100%', paddingLeft: 10, paddingRight: 10 }}
    >
      {renderInput()}
    </div>
  );
};

export default ApplicationField;
